// extracted by mini-css-extract-plugin
export default {"barContainer":"progress-bar_barContainer__aukZq","numbers":"progress-bar_numbers__cCXeu","myProgress":"progress-bar_myProgress__cj1tr","myBar":"progress-bar_myBar__jClAd"};